import { render } from "./pay-type.vue?vue&type=template&id=32a7188f&scoped=true"
import script from "./pay-type.vue?vue&type=script&lang=js"
export * from "./pay-type.vue?vue&type=script&lang=js"

import "./pay-type.vue?vue&type=style&index=0&id=32a7188f&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32a7188f"]])

export default __exports__